import React from 'react';
import {
  Toolbar,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import colors from '../../constants/colors';
import FullLogo from '../FullLogo';
import { desktopMinWidth } from '../../../utils/windowHelpers';
import ShortLogo from '../ShortLogo';
import FullLogoLight from '../FullLogoLight';
import ShortLogoLight from '../ShortLogoLight';
import { truncate } from '../../../utils/string';
import { useConnectWallet } from 'app/contexts/ConnectWalletContext';
import ConnectWalletFlow from 'app/containers/ConnectWalletFlow';
import { minDesktopWidth } from 'utils/domHelpers';
import { useHistory } from 'react-router';

const HeaderV2 = ({
  showNavlinks = true,
  headerTheme = 'light',
  redirectLink = false,
  walletAddress = '',
  showLogin = true,
  showConnectWallet = true,
}) => {
  const isLightTheme = headerTheme === 'light';
  const isBlueTheme = headerTheme === 'blue';
  const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      background: isLightTheme
        ? colors.white
        : isBlueTheme
        ? colors.darker_blue
        : colors.alt_black,
    },
    navlinks: {
      marginRight: 8,
      display: 'flex',
      alignItems: 'center',

      [minDesktopWidth]: {
        marginRight: theme.spacing(5),
      },
    },
    link: {
      position: 'relative',
      textDecoration: 'none',
      color: isLightTheme ? colors.black_33 : '#fff',
      fontSize: '14px',
      marginLeft: theme.spacing(6),
    },
    logo: {
      flexGrow: 1,
      cursor: 'pointer',
      marginLeft: '16px',
      [desktopMinWidth]: {
        marginLeft: '40px',
      },
    },
    auth: {
      display: 'flex',
      alignItems: 'center',
      color: colors.orange,
    },
    authImg: {
      marginRight: 8,
      width: 24,
      height: 24,
      borderRadius: '100%',
    },
    hideOnMobile: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    walletAddContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 24px',
      border: `1px solid ${colors.white_f2}`,
      borderRadius: 4,
      cursor: 'pointer',
      '&:hover': {
        color: colors.white_f2,
      },
    },
    walletDisconnect: {
      padding: '12px 24px',
      borderRadius: 4,
      background: '#25273D',
      cursor: 'pointer',

      position: 'absolute',
      top: '120%',
      left: 0,
      zIndex: 2,
    },
    dot: {
      width: 8,
      height: 8,
      background: '#40C595',
      marginRight: 8,
      borderRadius: '100%',
    },
    linkText: {
      fontSize: 14,
      color: '#f2f2f2',
      cursor: 'pointer',
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const history = useHistory();
  const {
    onConnectClick,
    walletAddress: contextWalletAddress,
    onDisconnect,
  } = useConnectWallet();

  const renderConnectWalletLinks = () => {
    const isHomePage = window.location.pathname === '/';

    if (isHomePage)
      return !!contextWalletAddress ? (
        <div
          className={classes.linkText}
          onClick={() => history.push('/tokens')}
        >
          My Wallet
        </div>
      ) : showConnectWallet ? (
        <div className={classes.linkText} onClick={onConnectClick}>
          Connect Wallet
        </div>
      ) : null;

    return !!contextWalletAddress ? (
      <div className={`${classes.link}`}>
        <div className={classes.walletAddContainer}>
          <div className={classes.dot} />
          {truncate(contextWalletAddress, 16, '')}
        </div>
        <div className={classes.walletDisconnect} onClick={onDisconnect}>
          Disconnect
        </div>
      </div>
    ) : showConnectWallet ? (
      <div className={`${classes.link}`} onClick={onConnectClick}>
        <div className={classes.walletAddContainer}>Connect your wallet</div>
      </div>
    ) : null;
  };

  return (
    <div className={classes.root}>
      <Toolbar>
        <div className={classes.logo}>
          <Link to="/" aria-label={'Home'}>
            {isMobile ? (
              isLightTheme ? (
                <ShortLogo />
              ) : (
                <ShortLogoLight />
              )
            ) : isLightTheme ? (
              <FullLogo />
            ) : (
              <FullLogoLight />
            )}
          </Link>
        </div>
        {showNavlinks && (
          <div className={classes.navlinks}>{renderConnectWalletLinks()}</div>
        )}
      </Toolbar>
      <ConnectWalletFlow />
    </div>
  );
};
export default HeaderV2;
